import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { setActiveView } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { sendVerifyAccountExistsRequest } from './service/index.js';
export const verifyAccountExistsThunk = createAsyncThunk('registration/registrationRequest', async (_, { rejectWithValue, dispatch, getState }) => {
    const state = getState();
    const email = state.forms.accountIdentifier.email.value;
    try {
        const response = await sendVerifyAccountExistsRequest({
            email,
        });
        if (response?.exists) {
            // TODO: replace that with navigateTo
            dispatch(setActiveView(FORM_TYPES.TWO_STEP_LOGIN));
        }
        else {
            // TODO: replace that with navigateTo
            dispatch(setActiveView(FORM_TYPES.TWO_STEP_REGISTRATION));
        }
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
// todo: small details check convention for initial states uppercase first letter
export const initialAccountIdentifierState = {
    email: {
        value: '',
        error: false,
        errorMessage: '',
    },
    isLoading: false,
};
export const accountIdentifierSlice = createSlice({
    name: 'accountIdentifier',
    initialState: initialAccountIdentifierState,
    reducers: {
        updateAccountIdentifierEmail: (state, actions) => {
            state.email.value = actions.payload;
        },
        updateEmailError: (state, actions) => {
            state.email.error = actions.payload;
        },
        updateEmailErrorMessage: (state, actions) => {
            state.email.errorMessage = actions.payload;
        },
    },
    extraReducers(builder) {
        builder.addCase(verifyAccountExistsThunk.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(verifyAccountExistsThunk.fulfilled, (state) => {
            state.isLoading = false;
        });
        builder.addCase(verifyAccountExistsThunk.rejected, (state) => {
            state.isLoading = false;
        });
    },
});
export const { updateAccountIdentifierEmail, updateEmailError, updateEmailErrorMessage, } = accountIdentifierSlice.actions;
const accountIdentifierState = (state) => state.forms.accountIdentifier;
export const accountIdentifierEmailSelector = createSelector(accountIdentifierState, ({ email }) => email);
export const isLoadingSelector = createSelector(accountIdentifierState, ({ isLoading }) => isLoading);
export default accountIdentifierSlice.reducer;
//# sourceMappingURL=accountIdentifierSlice.js.map